import { Component, OnInit, Input } from '@angular/core';

import { productSlider } from '../data';

@Component({
	selector: 'molla-clothing-collection',
	templateUrl: './clothing-collection.component.html',
	styleUrls: ['./clothing-collection.component.scss']
})

export class ClothingCollectionComponent implements OnInit {

	@Input() products = [];
	@Input() loaded = false;

	sliderOption = productSlider;
	attrs = ['featured', 'new', 'top'];
	titles = { "featured": "Featured", "new": "New", "top": "Best Seller" };

	constructor() { }

	ngOnInit(): void {
	}
}
